<template lang="pug">
  WtTile(vertical)
    WtTile.is-flex.is-align-content-center.is-flex-wrap-wrap.padding-12
      .column.is-8-desktop.is-12-mobile.is-flex.is-align-items-center.border-top-line
        WtTitle.m-0.mr-5.is-flex.is-align-items-center Members
        BDropdown(
          v-model="sortBy"
        )
          .sort-by-trigger(slot="trigger" slot-scope="{ active }")
            BButton(
              :label="sortBy ? _.find(sortByOptions, {value:sortBy}).label : 'Sort Members by'"
              :icon-right="active ? 'chevron-up' : 'chevron-down'"
            )
          template(v-for="option in sortByOptions")
            BDropdownItem(
              :value="option.value"
            ) {{option.label}}
      .column.is-4-desktop.is-12-mobile
        BInput(
          placeholder="Search"
          custom-class="is-rounded"
          type="search"
          icon="magnify"
          v-model="searchFilter"
          @input="onSearch"
        )
    WtTile.is-flex.is-flex-wrap-wrap
      template(v-for="member in displayedMembers")
        .column.is-3-desktop.is-6-tablet.is-12-mobile.member-list-column
          .box.has-shadow.member-container.is-flex.is-align-items-center.is-justify-content-center
            .is-flex.is-align-items-center.is-full-width
              EntityAvatar.mr-4(:image="member.avatar" is-rounded)
              div
                div.mb-1
                  .is-size-6.has-text-centered(v-if="coreProgramMeta.showRealNames" ) {{ member.name }}
                div
                  .fake-link(
                    @click="goToUserProfile(member.id)"
                  ) @{{member.username}}
    WtTile.is-justify-content-flex-end(parent)
      BPagination(
        :current="_.get(organizationMembersResponseObject, 'pagination.currentPage', 0)"
        :total="_.get(organizationMembersResponseObject, 'pagination.total', 0)"
        :per-page="_.get(organizationMembersResponseObject, 'pagination.perPage', 0)"
        @change="onPageChange"
      )


</template>

<script>
import WtTitle from "@@/WtTitle/WtTitle";
import WtTile from "@@/WtTile/WtTile";
import EntityAvatar from "@/components/WtEntityAvatar/WtEntityAvatar";
import WtRouterLink from "@@/WtRouterLink/WtRouterLink";

import { mapActions, mapGetters } from "vuex";

export default {
  name: "OrganizationMembers",

  components: {
    WtTitle,
    WtTile,
    EntityAvatar,
    WtRouterLink
  },

  props: {
    organizationId: {
      type: Number,
      default: 0
    },
    perPage: {
      type: Number,
      default: null
    }
  },
  data() {
    return {
      sortBy: null,
      sortByOptions: [
        { value: "last_visit", label: "Last Login" },
        { value: "user_numentries", label: "Most Step Entries" },
        { value: "user_stepstotal", label: "Most Steps" }
      ],
      searchFilter: null
    };
  },

  computed: {
    ...mapGetters("organizations", ["organizationMembersResponseObject"]),
    ...mapGetters("program", ["coreProgramMeta"]),

    displayedMembers() {
      return this._.get(this.organizationMembersResponseObject, "data", []);
    }
  },
  watch: {
    organizationId() {
      if (this.organizationId) {
        this.fetchOrganizationMembers(this.organizationId);
      }
    },
    sortBy() {
      if (this.sortBy) {
        this.onPageChange(1);
      }
    }
  },
  mounted() {
    if (this.organizationId) {
      this.fetchOrganizationMembers(this.organizationId);
    }

    this.onSearch = this._.debounce(async () => {
      this.onPageChange(1);
    }, 500);
  },

  methods: {
    ...mapActions("organizations", ["fetchMobileMembers"]),

    fetchOrganizationMembers: function(orgId) {
      this.fetchMobileMembers({ organizationId: orgId, perPage: this.perPage });
    },

    onPageChange(page) {
      this.fetchMobileMembers({
        organizationId: this.organizationId,
        perPage: this.perPage,
        page: page,
        sortBy: this.sortBy,
        sortOrder: this.sortBy ? "desc" : null,
        searchFilter: this.searchFilter,
        programId: this._.get(this.coreProgramMeta, "id", null)
      });
    },
    onSearch() {},
    goToUserProfile(id) {
      if (!id) {
        return;
      }
      var applink = {};
      applink.type = "friend";
      applink.value = id;
      // for iOS
      if (typeof window.webkit === "object") {
        window.webkit.messageHandlers.success.postMessage({
          data: JSON.stringify(applink)
        });
        //for Android
      } else if (typeof window.Android === "object") {
        window.Android.handleRegistration(JSON.stringify(applink));
      }
    }
  }
};
</script>

<style lang="sass" scoped>
.member-container
  height: 140px
.fake-link
  color: $grey
  text-decoration: underline
  cursor: pointer
@media screen and (max-width: 768px)
  .member-list-column
    padding-top: 0
    padding-bottom: 0
  .member-container
    border-radius: 0
    border-top: 1px solid $grey-light
    box-shadow: none !important
  .border-top-line
    border-top: 1px solid $grey-light
  .padding-12
    padding: 12px
.is-full-width
  width: 100%
</style>
